const getMailingList = (state, payload) => {
  state.mailingList = payload;
}
const mailReportStatus = (state, payload) => {
  state.mailReportData = payload
}

export default {
  getMailingList,
  mailReportStatus
}


// WEBPACK FOOTER //
// ./src/store/modules/mailing/mutations.js